// ===== frontend/src/App.js (Updated with Demo Route) =====
import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Header from './components/Layout/Header';
import Footer from './components/Layout/Footer';
import HomePage from './pages/HomePage';
import FormPage from './pages/FormPage';
import DemoPage from './pages/DemoPage';
import ScrollToTop from './components/Layout/ScrollToTop';


function App() {
  return (
    <Router>
      <ScrollToTop /> 
      <div style={{ minHeight: '100vh', display: 'flex', flexDirection: 'column', backgroundColor: '#f9fafb' }}>
        <Header />
        <main style={{ flex: 1 }}>
          <Routes>
            <Route path="/" element={<HomePage />} />
            <Route path="/form/:sessionId?" element={<FormPage />} />
            <Route path="/demo" element={<DemoPage />} />
          </Routes>
        </main>
        <Footer />
      </div>
    </Router>
  );
}

export default App;